import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL + '/admin_reports';


function getAdminReports(params) {
    return axios.get(`${url}/list?tab=` + params.tab + '&year=' + params.year + '&startWeek=' + params.startWeek + '&endWeek=' + params.endWeek)
        .then(response => {
            return {
                adminReportsList: response.data,
            };
        }).catch(err => {
            return {
                adminReportsList: err.response.data.error,
            };
        });
}

function getAdminDayReport(params) {
    return axios.get(`${url}/day?period=` + params.period)
        .then(response => {
            return {
                adminDayReport: response.data,
            };
        }).catch(err => {
            return {
                adminDayReport: err.response.data.error,
            };
        });
}


export default {
    getAdminReports,
    getAdminDayReport
};